export default (updateDate) => {
    const oneHour = 1000 * 60 * 60;
    return updateDate && parseInt(updateDate) + oneHour > new Date().getTime() 
}